import {
  DetailsList,
  DetailsListLayoutMode,
  getTheme,
  Icon,
  SelectionMode,
  Shimmer,
  Stack,
  Text
} from "@fluentui/react";

import { contractShipmentColumns } from "./ContractShipmentColumns";

import {
  type ContractShipmentAction,
  type ListContractShipmentsResponseItem,
  type ListContractShipmentsResponse
} from "@/interfaces/modules/contract-shipments";

const theme = getTheme();

interface ContractShipmentsContentProps {
  contractShipments: ListContractShipmentsResponse;
  canUpdate: boolean;
  canListCosts: boolean;
  isLoading: boolean;
  openDialog: (
    action: ContractShipmentAction,
    shipment?: ListContractShipmentsResponseItem
  ) => void;
}

function ContractShipmentsContentShimmer(): JSX.Element {
  return (
    <Stack tokens={{ childrenGap: 12 }}>
      <Shimmer />
      <Shimmer />
      <Shimmer />
    </Stack>
  );
}

function EmptyState(): JSX.Element {
  return (
    <Stack tokens={{ padding: 24, childrenGap: 8 }} horizontalAlign="center">
      <Icon
        iconName="DeliveryTruck"
        style={{ fontSize: 48, color: theme.palette.neutralSecondary }}
      />
      <Text>Nenhum envio cadastrado.</Text>
    </Stack>
  );
}

export function ContractShipmentsContent({
  contractShipments,
  canUpdate,
  canListCosts,
  isLoading,
  openDialog
}: ContractShipmentsContentProps): JSX.Element {
  if (isLoading) {
    return <ContractShipmentsContentShimmer />;
  }

  if (contractShipments.length === 0) {
    return <EmptyState />;
  }

  const columns = contractShipmentColumns({
    canUpdate,
    canListCosts,
    isLoading,
    openDialog
  });

  const centralizerWrapperStyle = {
    contentWrapper: {
      "& .ms-DetailsRow-fields": {
        alignItems: "center"
      },
      "& .ms-DetailsRow-cell": {
        minHeight: "auto"
      }
    }
  };

  return (
    <DetailsList
      items={contractShipments}
      columns={columns}
      selectionMode={SelectionMode.none}
      layoutMode={DetailsListLayoutMode.justified}
      styles={centralizerWrapperStyle}
      compact
    />
  );
}
